import containerItem from "./container.js";
import printStyleDefinition from "../definition/printStyle.js";
import imageFormat from "../definition/imageFormat.js";

export default class printContainer extends containerItem {
    objectType = "PrintContainerItem";
    PrintQuantity = 1;
    PrintPaper = null;
    PrintFormat = null;
    constructor(args = {}) {
        super(args, true);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        let contents = [];
        args = this.constructor.fromObjectToObject(args);
        super.objectToClassValue(args);
        this.PrintQuantity = args.printQuantity !== undefined ? args.printQuantity : 1;
        this.PrintPaper = args.printPaper ? this.getIdFromText(args.printPaper, printStyleDefinition) : this.getIdFromText("GLOSSY", printStyleDefinition);
        this.PrintFormat = args.printFormat ? this.getIdFromText(args.printFormat, imageFormat) : this.getIdFromText("Ajuster", imageFormat);
    }

    get PrintPaperName() {
        if (this.PrintPaper != null) {
            return printStyleDefinition.find(key => key.idSoft == this.PrintPaper).name;
        }
        return null;
    }
    get PrintFormatName() {
        if (this.PrintFormat != null) {
            return imageFormat.find(key => key.idSoft == this.PrintFormat).name;
        }
        return null;
    }

    static get Name() {
        return "printContainer";
    }
    static fromObject(object = {}) {
        return new this.prototype.constructor(object);
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        let returnData = {
            ...super.toExportObject(variableArray, ressourceArray),
            option: {
                printQuantity: this.PrintQuantity,
                printPaper: this.PrintPaperName,
                printFormat: this.PrintFormatName
            }
        }
        const contents = returnData.contents;
        const position = returnData.position;
        delete returnData.contents;
        delete returnData.position;
        returnData.contents = [{
            position: position,
            contents: contents
        }];
        return returnData;
    }
    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            printQuantity: this.PrintQuantity,
            printPaper: this.PrintPaperName,
            printFormat: this.PrintFormatName
        };
    }
    get changeableProperty() {
        return [
            ...super.changeableProperty,
            { name: "PrintQuantity", text: "Nombre d'impression", type: "numberInput", dataType: "number" },
            { name: "PrintPaper", text: "Type d'impression", type: "selectInput", dataType: "string", options: printStyleDefinition, optionsType: "idSoft" },
            { name: "PrintFormat", text: "Format d'impression", type: "selectInput", dataType: "string", options: imageFormat, optionsType: "idSoft" }
        ];
    }
    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            {
                name: "PrintQuantity",
                construct: Number,
                jsType: "Number",
            },
            {
                name: "PrintPaper",
                construct: Array,
                jsType: "Array",
            },
            {
                name: "PrintFormat",
                construct: Number,
                jsType: "Number",
            }
        ];
    }
}
